import { reactive } from "vue";
import { Options } from "vue-class-component";

import config from "@/config/config";
import i18n from "@/translation/i18n";
import PageBaseList from "@/pages/PageBaseList";
import TableLite from "@/components/table/TableLiteTs.vue";
import { Customer } from "@/domain/customer.model";
import Toggle from "@vueform/toggle/src/Toggle";

const { t } = i18n.global;

@Options({
  name: "customer-list",
  components: {
    TableLite,
    Toggle,
  },
  computed: {
    isLoading(): boolean {
      return this.$store.state.customer.isLoading;
    },
    totalRecordCount(): number {
      return this.$store.state.customer.customers?.total;
    },
    customers(): Customer[] {
      return this.$store.state.customer.customers?.data;
    },
  },
  watch: {
    customers: function () {
      this.table.rows = this.customers;
      this.table.totalRecordCount = this.totalRecordCount;
    },
    isLoading: function () {
      this.table.isLoading = this.isLoading;
    },
  },
})
export default class CustomerList extends PageBaseList {
  public table = TABLE;
  public filterCustom = {
    name: "",
    email: "",
    accept_newsletter: true,
    accept_terms_use: true,
    enabled: true,
  };

  public mounted(): void {
    this.url = "customer";
    this.module = config.modules.customer;
    this.table.rows = [];

    this.doSearch(0, this.per_page, "id", "asc");
  }

  public computed(): void {
    this.url = "customer";
    this.module = config.modules.customer;
    this.table.rows = [];

    this.doSearch(0, this.per_page, "id", "asc");
  }

  public doFilter() {
    this.doSearch(0, this.per_page, "id", "asc", this.filterCustom);
  }

  public clear() {
    this.filterCustom = {
      name: "",
      email: "",
      accept_newsletter: true,
      accept_terms_use: true,
      enabled: true,
    };

    this.doSearch(0, this.per_page, "id", "asc");
  }

  public doSearch(offset?: number, limit?: number, order?: string, sort?: string, filter?: Record<string, unknown>) {
    this.table.isReSearch = offset == undefined ? true : false;

    if (offset >= 10 || limit >= this.max_per_page) {
      limit = this.max_per_page;
    }

    this.$store
      .dispatch("customer/list", { offset, limit, order, sort, filter })
      .then(() => {
        this.table.sortable.order = order;
        this.table.sortable.sort = sort;
      })
      .catch(error => {
        console.log(error);
      });
  }

  public excluir(id: string | number) {
    this.$store
      .dispatch("customer/delete", id)
      .then(() => {
        this.table.isLoading;
      })
      .catch(() => {
        this.errorMessage = "Ocorreu um erro ao excluir.";
      });
  }
}

export const TABLE = reactive({
  isLoading: false,
  isReSearch: false,
  columns: [
    {
      label: t("labels.entity.id"),
      field: "id",
      sortable: true,
      isKey: true,
    },
    {
      label: t("labels.entity.name"),
      field: "name",
      sortable: true,
      columnStyles: "text-align: left",
    },
    {
      label: t("labels.entity.email"),
      field: "email",
      sortable: true,
      columnStyles: "text-align: left",
    },
    {
      label: t("labels.entity.acceptNewsletter"),
      field: "accept_newsletter",
      sortable: true,
      columnStyles: "text-align: center",
    },
    {
      label: t("labels.entity.acceptTermsUse"),
      field: "accept_terms_use",
      sortable: true,
      columnStyles: "text-align: center",
    },
    {
      label: t("labels.entity.active"),
      field: "enabled",
      sortable: true,
      columnStyles: "text-align: center",
    },
    {
      field: "actions",
    },
  ],
  rows: [{}],
  totalRecordCount: 0,
  sortable: {
    order: "id",
    sort: "asc",
  },
});
